import axios, { AxiosError } from "axios";
import { useQuery } from "react-query";

import { getAppConfigSetting } from "../utils/getAppConfigSetting";
import { GET_MARGIN_CALLS } from "./constants";
import queryKeys from "./queryKeys";

export interface CustomerSummaryData {
  accountName: string;
  correspondentCode: string;
  officeRepCode: string;
  closeRestriction: string;
  registeredRepCode: string;
  restrictReason: string;
  restrictDate: string;
  account: string;
  dayTradeCount: number;
  dayTraderType: string;
  patternDayTrader: number;
}
const useGetCustomerSummary = (accountId: string, processDate: string) => {
  const marginsApiURL = `${getAppConfigSetting("apiUrl")}${GET_MARGIN_CALLS}`;

  const fetchCustomerSummary = async () => {
    const { data } = await axios.get(
      `${marginsApiURL}/${accountId}/customer-summary?processDate=${processDate}`,
      {
        withCredentials: true,
      }
    );
    return data as CustomerSummaryData;
  };

  return useQuery<CustomerSummaryData, AxiosError>(
    [queryKeys.getCustomerSummary, accountId, processDate],
    fetchCustomerSummary
  );
};

export default useGetCustomerSummary;
